import {Reducer} from "redux";

import * as c from "./config.constant";

export interface ConfigState {
    outletId?: string;
    youtubeUrl?: string;
    runningText?: string;
}

const initialState: ConfigState = {
    outletId: '',
    youtubeUrl: '',
    runningText: ''
}

const getKeys = (payload: any) => Object.keys(payload as keyof ConfigState);
const reducer: Reducer<ConfigState> = (state = initialState, action): ConfigState => {
    const { type, payload } = action;
    switch (type) {
        case c.SET_OUTLET_ID:
            state.outletId = payload;
            return { ...state };

        case c.SET_BATCH_CONFIG:
            getKeys(payload).forEach(key => {
                state[key as keyof ConfigState] = payload[key];
            })
            return { ...state };

        default:
            return state
    }
}


export default reducer;